import { render, staticRenderFns } from "./ImagesInformation.vue?vue&type=template&id=244adb5e&"
import script from "./ImagesInformation.vue?vue&type=script&lang=ts&"
export * from "./ImagesInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports